// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    '使用类似以下示例的完成日期重试：' + p['dateExample'] + '。',
  chart_labelGroup: () => '组',
  chart_labelSeries: () => '系列',
  chart_labelValue: () => '值',
  checkboxSet_requiredMessageDetail: () => '必需',
  checkbox_requiredMessageDetail: () => '必需',
  close: () => '关闭',
  collection_noData: () => '没有可显示的数据。',
  collection_selectAllRows: () => '选择所有行',
  collection_selectRow: (p: { ROW_NAME: string }) => '选择行 ' + p['ROW_NAME'],
  collection_sortDisabled: () => '不可排序',
  collection_sortEnabled: () => '可排序',
  confirmation: () => '确认',
  dataVisualization_labelAndValue: (p: { LABEL: string; VALUE: string }) =>
    p['LABEL'] + ': ' + p['VALUE'],
  dataVisualization_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' 个，共 ' + p['totalCount'] + ' 个',
  dataVisualization_noData: () => '没有可显示的数据',
  dataVisualization_stateSelected: () => '选定',
  dataVisualization_stateUnselected: () => '未选定',
  error: () => '错误',
  expandableList_expandCollapseInstructionText: () => '使用箭头键展开和折叠',
  expandableList_groupCollapse: () => '折叠',
  expandableList_groupExpand: () => '展开',
  filePicker_addFiles: () => '添加文件',
  filePicker_dropzonePrimaryText: () => '拖放',
  filePicker_dropzoneSecondaryText: () => '选择一个文件或将文件放置在此处',
  filePicker_dropzoneSecondaryTextMultiple: () => '选择文件或将文件放置在此处。',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    '无法上载以下类型的文件: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => '一次上载一个文件',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    '无法上载以下类型的文件: ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => '未知',
  formControl_clear: () => '清除',
  formControl_day: () => '天',
  formControl_helpAvailable: () => '帮助可用',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    '您已达到 ' +
    (({ one: '1 个字符' } as Partial<Record<Intl.LDMLPluralRule, string>>)[
      new Intl.PluralRules('zh-Hans').select(p['CHARACTER_LIMIT'])
    ] || new Intl.NumberFormat('zh-Hans').format(p['CHARACTER_LIMIT']) + ' 个字符') +
    ' 的限制。',
  formControl_loading: () => '正在加载',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    '超过了最大长度 ' + p['MAX_LENGTH'] + '。',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    '剩余 ' + p['CHARACTER_COUNT'] + ' 个字符。',
  formControl_month: () => '月',
  formControl_readOnly: () => '只读',
  formControl_requiredMessageDetail: () => '输入值。',
  formControl_year: () => '年',
  gantt_labelDate: () => '日期',
  gantt_labelEnd: () => '结束',
  gantt_labelLabel: () => '标签',
  gantt_labelRow: () => '行',
  gantt_labelStart: () => '开始',
  indexer_disabledLabel: (p: { SECTION: string }) => p['SECTION'] + '。未找到匹配的区段。',
  indexer_keyboardInstructionText: () => '按 Enter 键以选择值。',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    '介于 ' + p['FROM_SECTION'] + ' 到 ' + p['TO_SECTION'] + ' 之间',
  indexer_touchInstructionText: () => '双击并按住以进入手势模式, 然后向上或向下拖动以调整值。',
  info: () => '信息',
  inputDateMask_date_cleared: () => '清除日期',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => '空',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'yyyy',
  inputNumber_converterParseError: () => '请输入数字。',
  inputNumber_decrease: () => '减少',
  inputNumber_increase: () => '增加',
  inputPassword_hidden: () => '密码已隐藏',
  inputPassword_hide: () => '隐藏密码',
  inputPassword_show: () => '显示密码',
  list_suggestion: () => '建议',
  messageToast_allMessagesClosed: () => '所有快显 (toast) 消息都已关闭。',
  message_close: () => '关闭',
  message_confirmation: () => '成功',
  message_error: () => '错误',
  message_info: () => '信息',
  message_navigationFromMessagesRegion: () => '正在输入消息区域。按 F6 可返回到之前选中的元素。',
  message_navigationToMessagesRegion: () => '消息区域有新消息。使用 F6 可导航到最新的消息区域。',
  message_warning: () => '警告',
  noData_message: () => '没有要显示的项',
  overflowItemLabel: () => '更多选项卡',
  plural_separator: () => ', ',
  progressIndeterminate: () => '进行中',
  radio_helpForRadio: () => '单选按钮帮助',
  radio_requiredMessageDetail: () => '选择一个值。',
  selectMultiple_apply: () => '应用',
  selectMultiple_back: () => '返回',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () => '按 Backspace 或 Delete 键删除所选值。',
  selectMultiple_selectedValues: () => '所选值',
  selectMultiple_showSelectedValues: () => '仅显示选定值。',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    '已选择 ' + p['VALUE_COUNT'] + ' 个值。',
  select_addToList: () => '添加到列表',
  select_addToListAvailable: () => '添加到列表可用',
  select_moreSearchOptions: () => '更多搜索选项',
  select_moreSearchOptionsAvailable: () => '更多搜索选项可用',
  select_noMatchesFound: () => '找不到匹配项。',
  select_oneMatchFound: () => '找到一个匹配',
  select_requiredMessageDetail: () => '选择一个值。',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => '找到 ' + p['TOTAL_SIZE'] + ' 个匹配项',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    '找到 ' + p['TOTAL_SIZE'] + ' 个或更多匹配项',
  selector_selected: () => '复选框已选中',
  selector_unselected: () => '复选框未选中',
  tabBarNavigationList_removeCueText: () => '可删除',
  timeComponent_tooltipZoomIn: () => '放大',
  timeComponent_tooltipZoomOut: () => '缩小',
  train_current: () => '当前',
  train_message_type: () => '消息类型',
  train_not_visited: () => '未访问',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    '第 ' + p['currentStep'] + ' 步，共 ' + p['numberOfSteps'] + ' 步',
  train_visited: () => '已访问',
  userAssistance_learnMore: () => '了解更多',
  userAssistance_required: () => '必需',
  viz_drillable: () => '可钻取',
  warn: () => '警告'
};
export default bundle;
